(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  const chooseCleanProductImage = () => {
    if (!window.location.pathname.includes('mini-aspirateur-sans-fil-pour-voiture-compact-et-puissant')) return
    window.setTimeout(() => {
      const cleanImageControl = document.querySelector('[aria-label="Diapositive 5 sur 7"]')
      if (cleanImageControl instanceof HTMLButtonElement) cleanImageControl.click()
    }, 450)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', chooseCleanProductImage, { once: true })
  } else {
    chooseCleanProductImage()
  }

  document.addEventListener('shopify:section:load', chooseCleanProductImage)

  const mobileContentOrigins = new WeakMap()
  const mobileProductLayout = window.matchMedia('(max-width: 749px)')

  const rememberMobileOrigin = (element) => {
    if (!element || mobileContentOrigins.has(element)) return
    mobileContentOrigins.set(element, {
      parent: element.parentNode,
      nextSibling: element.nextSibling,
    })
  }

  const restoreMobileOrigin = (element) => {
    const origin = mobileContentOrigins.get(element)
    if (origin?.parent?.isConnected) origin.parent.insertBefore(element, origin.nextSibling)
  }

  const buildMobileInformationCards = (descriptionBlock) => {
    const content = descriptionBlock.querySelector('.rte') || descriptionBlock
    if (content.querySelector(':scope > .product-mobile-info-card')) return

    let currentCard = null
    let headingIndex = 0

    Array.from(content.children).forEach((element) => {
      if (element.matches('h2, h3')) {
        currentCard = document.createElement('section')
        currentCard.className = 'product-mobile-info-card'

        if (element.matches('h2')) {
          currentCard.classList.add('product-mobile-description-card')
        } else {
          headingIndex += 1
          if (headingIndex === 1) currentCard.classList.add('product-mobile-benefits-card')
        }

        content.insertBefore(currentCard, element)
      }

      if (currentCard) currentCard.append(element)
    })
  }

  const removeMobileInformationCards = (descriptionBlock) => {
    const content = descriptionBlock.querySelector('.rte') || descriptionBlock
    content.querySelectorAll(':scope > .product-mobile-info-card').forEach((card) => {
      while (card.firstChild) content.insertBefore(card.firstChild, card)
      card.remove()
    })
  }

  const positionMobileProductContent = () => {
    document.querySelectorAll('.product-details').forEach((details) => {
      const detailsCard = details.querySelector(':scope > .group-block') || details.querySelector('.group-block')
      if (!detailsCard) return

      const detailsContent = detailsCard.querySelector(':scope > .group-block-content') || detailsCard
      const descriptionBlock = Array.from(detailsContent.children).find(
        (child) =>
          child.matches('rte-formatter.rte, .text-block.rte') &&
          child.textContent.trim().length > 0
      )
      if (!descriptionBlock) return

      rememberMobileOrigin(descriptionBlock)

      if (mobileProductLayout.matches) {
        descriptionBlock.classList.add('product-mobile-description-flow')
        detailsCard.after(descriptionBlock)
        buildMobileInformationCards(descriptionBlock)
      } else {
        removeMobileInformationCards(descriptionBlock)
        descriptionBlock.classList.remove('product-mobile-description-flow')
        restoreMobileOrigin(descriptionBlock)
      }
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionMobileProductContent, { once: true })
  } else {
    positionMobileProductContent()
  }

  mobileProductLayout.addEventListener('change', positionMobileProductContent)
  document.addEventListener('shopify:section:load', positionMobileProductContent)

  } catch(e) { console.error(e); }
})();
})();
